import {
  PartialMoment,
  labelHasNameAndSet,
  momentHasAccount,
  momentHasDaySegment,
  momentHasLabelArray,
  momentHasServiceArray,
  serviceHasSystemName,
} from '../momentTypes'
import { NO_GROUPING_CATEGORY_ID } from '../sortHelpers'
import { WeekViewSortType } from '../types'

type MomentGetter = (
  moment: PartialMoment,
  parentCategory?: string
) => string[] | null

const getMomentTime: MomentGetter = (moment) => {
  momentHasDaySegment(moment)
  return moment.day_segment ? [moment.day_segment] : null
}

const getMomentChannels: MomentGetter = (moment) => {
  if (!momentHasServiceArray(moment)) {
    return null
  }

  const services = moment.services

  if (services.length === 0) return null

  const channelNames = services
    .filter(serviceHasSystemName)
    .map<string>((service) => service.system_name)

  return channelNames
}

const getMomentAccount: MomentGetter = (moment) => {
  if (!momentHasAccount(moment)) return null
  return [moment.account.name]
}

const getMomentLabels: MomentGetter = (moment, parentCategory) => {
  if (!parentCategory) {
    throw new Error(
      'Target Label Set is required when grouping Moments by Label Set.'
    )
  }

  if (!momentHasLabelArray(moment)) {
    return null
  }

  const labels = moment.labels

  if (labels.length === 0) return null

  const validLabels = labels.filter(labelHasNameAndSet)

  return validLabels
    .filter((label) => label.label_set.name === parentCategory)
    .map<string>((label) => label.name)
}

const getMomentNone: MomentGetter = () => [NO_GROUPING_CATEGORY_ID]

export const makeCategoryGetter = (groupBy: WeekViewSortType): MomentGetter => {
  switch (groupBy) {
    case WeekViewSortType.Time:
      return getMomentTime
    case WeekViewSortType.Channel:
      return getMomentChannels
    case WeekViewSortType.Account:
      return getMomentAccount
    case WeekViewSortType.LabelSet:
      return getMomentLabels
    case WeekViewSortType.None:
      return getMomentNone
  }
}
